module.exports = __webpack_public_path__ + "img/placeholder.f35c8c14.gif";